import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Study } from 'src/app/data/study';
import { BookService } from 'src/app/services/book.service';
import { StudiesService } from 'src/app/services/studies.service';
import { Tab } from 'src/app/tabs/book-pdf-flipbook/book-pdf-flipbook-vertical/bottom-nav/tab.type';

export type SideMenuButton = 'download' | 'share' | 'info' | 'history' | 'report' | 'viewer' | 'book';

@Component({
  selector: 'app-side-menu',
  templateUrl: './side-menu.component.html',
  styleUrls: ['./side-menu.component.css']
})
export class SideMenuComponent {

  @Input() opened = false;

  @Input() actualBookStudies: Study[] = [];

  @Input() visibleButtons?: SideMenuButton[];

  @Output() close = new EventEmitter<void>();
  @Output('onClickShare') onClickShareEmitter = new EventEmitter<string>();
  @Output('onClickInfo') onClickInfoEmitter = new EventEmitter<void>();
  @Output('onClickChangeTab') onClickChangeTabEmitter = new EventEmitter<Tab>();
  @Output('onClickViewer') onClickViewerEmitter = new EventEmitter<void>();
  

  downloadExpanded = false;

  constructor(
    private bookService: BookService,
    private studiesService: StudiesService
  ) { }

  toggleDownload(): void {
    this.downloadExpanded = !this.downloadExpanded;
  }

  openShareModal(){
    this.onClickShareEmitter.emit();
  }

  openInfoModal(){
    this.onClickInfoEmitter.emit();
  }

  changeTab(tab: Tab){
    this.onClickChangeTabEmitter.emit(tab);
    this.close.emit();
  }

  downloadReports(){
    this.studiesService.downloadReport(this.bookService.currentBook!.studyUIDs);
  }

  isVisible(button: SideMenuButton): boolean {
    if (!this.visibleButtons || this.visibleButtons.length === 0) return true;
    return this.visibleButtons.includes(button);
  }
  
}
